// extracted by mini-css-extract-plugin
export default {"RegistryViewHeader__mobileActions":"MobileActions-styles__RegistryViewHeader__mobileActions__iHEUO","shimmer":"MobileActions-styles__shimmer__ONXPX"};